<template>
  <GwMenu
    ref="gwmenu"
    placement="bottom"
    :trigger="trigger"
    :isInside="true"
    :flOptions="{ offset: -1 }"
  >
    <template #opener="{ methods }">
      <div
        class="gw_btn gw_btn_small clr-grey text-small clr-hover gw_btn_text csst"
        style="--csst-min-after-height: 0px"
        @click="
          e => {
            if (trigger === 'hover') {
              e.preventDefault()
              methods.toggleOpen()
              copyToClipboard()
            }
          }
        "
      >
        <div
          class="mdi mdi-content-copy text-small"
          style="margin: 0 0.125rem 0 0"
        ></div>
        {{ $t('btn.copy') }}
        <div
          v-if="copied"
          class="csst_content clr-white trapresitm_btn_tooltip text-nowrap"
          style="--padding: 0"
          :style="
            copied
              ? `
                  background:var(${nadaPurchased ? '--clr-error' : '--clr-primary'});
                  ${!flipped ? 'right' : 'left'}:0;top:100%;
                  `
              : `${!flipped ? 'right' : 'left'}:0;top:100%;
                  `
          "
          :class="{ csst_content_visible: copied }"
        >
          <div
            class="pa-1"
            v-html="
              nadaPurchased
                ? $t('browse.range_only_for_subscribed_users')
                : $t('browse.range_in_clipboard')
            "
          ></div>
        </div>
      </div>
    </template>
    <template #default="{ methods }">
      <GwBtns
        class="gw_menu gwbtns_vertical_grey"
        :options="[{ id: 'copy_all' }, ...solution]"
        @click="
          (_e, item) => {
            methods.toggleOpen(false)
            if (item.id === 'copy_all') {
              copyToClipboard()
            } else {
              computeRange(item)
            }
          }
        "
      >
        <template #default="{ item }">
          <div v-if="item.id === 'copy_all'">{{ $t('common.copy_whole_range') }}</div>
          <div v-else>
            {{ item.display_name }}
            <span v-html="getBetHtml({ showBetsIn, a: item })"></span>
          </div>
        </template>
      </GwBtns>
    </template>
  </GwMenu>
</template>

<script>
import GwMenu from '@/components/lib/GwMenu'
import GwBtns from '@/components/lib/GwBtns'
import allCombos from '@/helpers/allCombos.json'
import tier_mix from '@/mixins/tier_mix'
import format_mix from '@/mixins/format_mix'

export default {
  name: 'RangeCopyBtn',

  components: {
    GwMenu,
    GwBtns,
  },
  mixins: [tier_mix, format_mix],
  props: {
    hasActions: Boolean,
    range: Array,
    solution: { default: () => [] },
    flipped: Boolean,
    showBetsIn: String,
  },
  data() {
    // TODO we should do this globbaly in app -
    // to create sometype if global variable with all these props
    // pointer, device, etc...

    this.trigger = matchMedia('(pointer:fine)').matches ? 'hover' : 'click'
    return {
      copied: false,
      tooltipValue: false,
    }
  },
  methods: {
    computeRange(item) {
      const actionRange = item.strategy.map((i, idx) => this.range[idx] * i)
      this.copyToClipboard(actionRange)
    },
    copyToClipboard(actionRange) {
      this.tooltipValue = true
      this.copied = true
      if (!this.nadaPurchased) {
        const ranges = (actionRange || this.range)
          .map((i, idx) => {
            const roundedValue = i % 1 !== 0 ? Math.round(i * 1e12) / 1e12 : i // Round to 12 decimal if needed for flopzilla compatibility
            return {
              text: `${allCombos[idx]}: ${roundedValue}`,
              value: roundedValue,
            }
          })
          .filter(i => i.value)
          .map(i => i.text)
        // 2d2c:0.375,2h2c:0.375,...
        // https://stackoverflow.com/questions/1685680/how-to-avoid-scientific-notation-for-large-numbers-in-javascript
        // didnt sove this yet
        // https://app.gtowizard.com/solutions?gametype=MTT6mGeneral&depth=80.125&gmff_stacks_type=SYMMETRIC&gmfft_sort_key=0&gmfft_sort_order=asc&soltab=range&stacks=80.125-80.125-80.125-80.125-80.125-80.125&history_spot=6&preflop_actions=R2.1-F-F-F-F-R10.5
        // copy raise 22.05 and get Kc4c: 2e-8 (number with scientific notation)
        navigator.clipboard.writeText(ranges.join(','))
      }
      setTimeout(
        () => {
          this.tooltipValue = false
          setTimeout(() => {
            this.copied = false
          }, 300)
        },
        this.nadaPurchased ? 1500 : 1500,
      )
    },
  },
}
</script>
